<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
<ng-template #customLoadingTemplate></ng-template>

<!-- begin::User Panel-->
<div id="kt_quick_user" class="offcanvas p-10" [ngClass]="extrasUserOffcanvasDirection">
	<!-- begin::Close button -->
	<button type="button" id="kt_quick_user_close" class="user-offcanvas-close" aria-label="Cerrar panel" title="Cerrar">
		<span class="close-bar"></span>
		<span class="close-bar"></span>
	</button>
	<!-- end::Close button -->
	<ng-container *ngIf="_userSession">
		<!--end::Header-->
		<!--begin::Content-->
		<div class="offcanvas-content pr-5 mr-n5">
			<!--begin::Header-->
			<div class="mt-5 row">				
				  <div class="col-8">
					<a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"> {{ _userSession.firstName }} {{ _userSession.lastName }} </a>
					<div class="text-muted mt-1">{{ _userSession.cargo }}</div>
					<div class="navi mt-2">
						<a href="#" class="navi-item">
							<span class="navi-link p-0 pb-2">
								<span class="navi-icon mr-1">
									<span [inlineSVG]="'./assets/media/svg/icons/Communication/Mail-notification.svg'" cacheSVG="true" class="svg-icon svg-icon-lg svg-icon-primary"></span>
								</span>
								<span class="navi-text text-muted text-hover-primary">{{ _userSession.email }}</span>
							</span>
						</a>

						<a class="btn btn-sm btn-light-primary font-weight-bolder py-2 px-5 cursor-pointer" (click)="logout()">Cerrar sesión</a>
					</div>
				  </div>
				  <div class="col-4 mt-2">
					<ng-container *ngIf="emisor.logo && emisor.logo.length > 200">
						<ng-container *ngIf="!logoError; else botonAgregarLogo">
						<img 
							[src]="'data:image/png;base64,' + emisor.logo" 
							alt="Logo de la empresa" 
							class="fill" 
							(error)="handleImageError()">
						</ng-container>
					  </ng-container>
					<ng-template #botonAgregarLogo>
						<button class="btn-primary2" (click)="openEmisorLogosList()">
							<img src="assets\media\svg\icons\Design\subir_imagen_1.svg" style="height: 4rem; width: auto; text-align: center; margin-left: 3px;" title="Subir logo" >
						</button>
					</ng-template>				  
				</div>			  
				</div>
			  
			<!-- <div class="d-flex align-items-center mt-5">
				<div class="d-flex flex-column">
					<a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"> {{ _userSession.firstName }} {{ _userSession.lastName }} </a>
					<div class="text-muted mt-1">{{ _userSession.cargo }}</div>
					<div class="navi mt-2">
						<a href="#" class="navi-item">
							<span class="navi-link p-0 pb-2">
								<span class="navi-icon mr-1">
									<span [inlineSVG]="'./assets/media/svg/icons/Communication/Mail-notification.svg'" cacheSVG="true" class="svg-icon svg-icon-lg svg-icon-primary"></span>
								</span>
								<span class="navi-text text-muted text-hover-primary">{{ _userSession.email }}</span>
							</span>
						</a>

						<a class="btn btn-sm btn-light-primary font-weight-bolder py-2 px-5 cursor-pointer" (click)="logout()">Cerrar sesión</a>
					</div>
				</div>
				<div class="d-flex flex-column">
					LOGO
				</div>
			</div> -->
			<!--end::Header-->
			<!--begin::Separator-->
			<div class="separator separator-dashed mt-8 mb-5"></div>
			<!--end::Separator-->

			<!--begin::Nav-->
			<div class="navi navi-spacer-x-0 p-0">
				<!--begin::Item-->
				<mat-accordion class="mb-1">
					<mat-expansion-panel class="pt-4 pb-4">
						<mat-expansion-panel-header class="pt-2 pb-2">
							<a class="navi-item cursor-pointer">
								<div class="navi-link">
									<div class="symbol symbol-40 bg-light mr-1">
										<div class="symbol-label">
											<img src="./assets/media/svg/cs/registered.svg" class="img-fluid" />
										</div>
									</div>
									<div class="navi-text">
										<div class="font-weight-bold">Mi Cuenta</div>
										<div class="text-muted">Datos y seguridad</div>
									</div>
								</div>
							</a>
						</mat-expansion-panel-header>
						<div class="pt-8 pb-6">
							<div class="d-flex align-items-center justify-content-between">
								<span class="font-weight-bold mr-2">RUT:</span>
								<span class="text-muted">{{ _user.rut }}-{{ _user.dv }}</span>
							</div>
							<div class="d-flex align-items-center justify-content-between">
								<span class="font-weight-bold mr-2">Nombre:</span>
								<span class="text-muted">{{ _user.nombre }} {{ _user.apellidos }}</span>
							</div>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold mr-2">Email:</span>
								<a href="#" class="text-muted text-hover-primary">{{ _user.email }}</a>
							</div>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold mr-2">Teléfono:</span>
								<span class="text-muted">{{ _user.telefono }}</span>
							</div>
						</div>
						<a (click)="goToMiCuenta()" class="btn btn-light-primary font-weight-bold py-3 px-6 mb-2 text-center btn-block">Ir a Mi Cuenta</a>
					</mat-expansion-panel>

					<!--begin::Item-->

					<mat-expansion-panel class="pt-4 pb-4">
						<mat-expansion-panel-header>
							<a class="navi-item cursor-pointer pt-4 pb-4">
								<div class="navi-link">
									<div class="symbol symbol-40 bg-light mr-3">
										<div class="symbol-label">
											<img src="./assets/media/svg/cs/office-building.svg" class="img-fluid" />
										</div>
									</div>

									<div class="navi-text">
										<div class="font-weight-bold">Perfil Empresa</div>
										<div class="text-muted">Configuración de tu empresa</div>
									</div>
								</div>
							</a>
						</mat-expansion-panel-header>
						<div class="pt-8 pb-6">
							<div class="d-flex align-items-center justify-content-between">
								<span class="font-weight-bold mr-2">RUT:</span>
								<span class="text-muted">{{ emisor.rutString }}</span>
							</div>
							<div class="d-flex align-items-center justify-content-between">
								<span class="font-weight-bold mr-2">Razón Social:</span>
								<span class="text-muted">{{ emisor.razonSocial }}</span>
							</div>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold mr-2">Email:</span>
								<a href="#" class="text-muted text-hover-primary">{{ emisor.correoPar }}</a>
							</div>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold mr-2">Teléfono:</span>
								<span class="text-muted">{{ emisor.telefono }}</span>
							</div>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold mr-2">Ambiente:</span>
								<span *ngIf="emisor.ambiente == 0" class="label label-inline label-lg label-warning">Certificación</span>
								<span *ngIf="emisor.ambiente == 1" class="label label-inline label-lg label-success">Producción</span>
							</div>
						</div>
						<a (click)="goToCompanyProfile()" class="btn btn-light-success font-weight-bold py-3 px-6 mb-2 text-center btn-block">Ir a Perfil de Empresa</a>
					</mat-expansion-panel>

					<!--end:Item-->

					<!--begin::Item-->

					<mat-expansion-panel class="pt-4 pb-4" *ngIf="planActivo && permissions.getPermission('82').asignado && !hasReseller">
						<mat-expansion-panel-header class="pt-4 pb-4">
							<a *ngIf="!hasReseller" class="navi-item cursor-pointer">
								<div class="navi-link">
									<div class="symbol symbol-40 bg-light mr-3">
										<div class="symbol-label">
											<img src="./assets/media/svg/cs/profit.svg" class="img-fluid" />
										</div>
									</div>
									<div class="navi-text">
										<div class="font-weight-bold">Tu plan</div>
										<div class="text-muted">Controla y gestiona tu plan</div>
									</div>
								</div>
							</a>
						</mat-expansion-panel-header>
						<div class="pt-8 pb-6">
							<div class="d-flex align-items-center justify-content-between">
								<span class="font-weight-bold mr-2">Plan:</span>
								<span class="text-muted">{{ planActivo.nombrePlan }}</span>
							</div>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold mr-2">Caduca:</span>
								<a href="#" class="text-muted text-hover-primary">{{ planActivo.fechaCaducidad | date : "dd/MM/y" }}</a>
							</div>
							<div class="d-flex align-items-center justify-content-between">
								<span class="font-weight-bold mr-2">Estado:</span>
								<span *ngIf="planActivo.diasDiferencia > 0 && !(!planActivo || !planActivo.pagado)" class="label label-lg label-inline label-success">Al día</span>
								<span *ngIf="planActivo.diasDiferencia > 0 && (!planActivo || !planActivo.pagado)" class="label label-lg label-inline label-warning">Demo</span>
								<span *ngIf="planActivo.diasDiferencia <= 0 && planActivo.diasDiferencia >= -15" class="label label-lg label-inline label-danger">En mora</span>
								<span *ngIf="planActivo.diasDiferencia < -15" class="label label-lg label-inline label-warning">Plan sin vigencia</span>
							</div>
						</div>
						<a (click)="goToAccount()" class="btn btn-light-success font-weight-bold py-3 px-6 mb-2 text-center btn-block" id="irAPlan">Ir al Plan</a>
					</mat-expansion-panel>
				</mat-accordion>
				<!--end:Item-->
			</div>
			<!--end::Nav-->

			<!--begin::Separator-->
			<div class="separator separator-dashed my-7"></div>

			<div *ngIf="!hasReseller && _userSession.planes && _userSession.planes.length > 0" class="alert alert-custom alert-white alert-shadow fade show gutter-b" role="alert">
				<div class="alert-icon">
					<span class="svg-icon svg-icon-primary svg-icon-xl">
						<svg viewBox="-32 0 511 511.9949" xmlns="http://www.w3.org/2000/svg">
							<path
								d="m143.921875 106.464844-53.203125-7.285156c-16.472656-2.253907-31.660156 9.273437-33.917969 25.75l-20.957031 153.066406 10.398438 94.113281-43.71875 100.328125c-5.347657 12.269531.261718 26.550781 12.53125 31.898438 12.308593 5.363281 26.570312-.308594 31.898437-12.535157l46.277344-106.191406c1.679687-3.847656 2.328125-8.0625 1.886719-12.234375l-9.371094-88.546875 62.96875 8.621094 20.957031-153.066407c2.253906-16.476562-9.273437-31.660156-25.75-33.917968zm0 0"
								fill="#5f6e9b" />
							<path d="m119.054688 488.949219-5.660157-115.21875-17.269531-100.066407c-2.277344-13.191406 6.570312-25.726562 19.757812-28.003906s25.726563 6.570313 28.003907 19.757813l17.519531 101.523437c.167969.972656.277344 1.949219.324219 2.933594l5.734375 116.695312c.660156 13.367188-9.644532 24.738282-23.015625 25.394532-13.363281.660156-24.734375-9.648438-25.394531-23.015625zm0 0" fill="#414b82" />
							<path d="m309.253906 511.925781c-13.367187-.65625-23.675781-12.027343-23.015625-25.394531l5.734375-116.695312c.046875-.980469.15625-1.960938.324219-2.929688l17.519531-101.523438c2.277344-13.191406 14.816406-22.035156 28.003906-19.757812 13.1875 2.273438 22.035157 14.8125 19.757813 28l-17.269531 100.066406-5.660156 115.21875c-.65625 13.367188-12.027344 23.675782-25.394532 23.015625zm0 0" fill="#748488" />
							<path d="m375.382812 491.609375-17.480468-108.496094c-.339844-2.117187-.398438-4.269531-.171875-6.402343l10.488281-99.132813c1.40625-13.308594 13.328125-22.960937 26.648438-21.550781 13.3125 1.410156 22.957031 13.339844 21.550781 26.648437l-10.148438 95.917969 16.964844 105.308594c2.128906 13.210937-6.859375 25.652344-20.070313 27.78125-13.25 2.132812-25.65625-6.886719-27.78125-20.074219zm0 0" fill="#55696e" />
							<path d="m241.507812 263.523438 78.097657-20.28125c6.546875-1.699219 11.804687-6.5625 14.011719-12.953126l32.097656-92.96875c3.640625-10.546874-1.957032-22.042968-12.5-25.683593-10.539063-3.644531-22.039063 1.957031-25.679688 12.5l-28.5625 82.734375-67.617187 17.5625c-10.792969 2.800781-17.273438 13.824218-14.46875 24.621094 2.800781 10.78125 13.816406 17.277343 24.621093 14.46875zm0 0" fill="#ba6746" />
							<path d="m148.714844 293.449219-112.871094-15.453125 20.957031-153.066406c2.257813-16.476563 17.445313-28.003907 33.917969-25.746094l53.203125 7.28125c16.476563 2.257812 28.003906 17.441406 25.75 33.917968zm0 0" fill="#64afff" />
							<path d="m193.886719 44.574219c0 24.617187-19.957031 44.574219-44.574219 44.574219s-44.574219-19.957032-44.574219-44.574219c0-24.617188 19.957031-44.574219 44.574219-44.574219s44.574219 19.957031 44.574219 44.574219zm0 0" fill="#ffb69e" />
							<path d="m213.328125 269.558594-78.09375-20.28125c-6.546875-1.703125-11.804687-6.5625-14.015625-12.957032l-32.09375-92.96875c-3.640625-10.542968 1.957031-22.039062 12.5-25.679687 10.539062-3.648437 22.039062 1.957031 25.679688 12.5l28.5625 82.730469 67.613281 17.5625c10.796875 2.804687 17.277343 13.828125 14.472656 24.621094-2.800781 10.78125-13.820313 17.277343-24.625 14.472656zm0 0" fill="#ffb69e" />
							<path d="m304.972656 293.449219 112.867188-15.453125-20.957032-153.066406c-2.253906-16.476563-17.441406-28.003907-33.917968-25.746094l-53.199219 7.28125c-16.476563 2.257812-28.003906 17.441406-25.75 33.917968zm0 0" fill="#ffda52" />
							<path d="m348.949219 44.574219c0 24.617187-19.957031 44.574219-44.578125 44.574219-24.617188 0-44.574219-19.957032-44.574219-44.574219 0-24.617188 19.957031-44.574219 44.574219-44.574219 24.621094 0 44.578125 19.957031 44.578125 44.574219zm0 0" fill="#ba6746" />
							<path d="m444.703125 269.089844 2.222656-80.652344c.1875-6.761719-3.023437-13.167969-8.550781-17.0625l-80.386719-56.671875c-9.117187-6.425781-21.714843-4.246094-28.144531 4.871094-6.429688 9.113281-4.246094 21.714843 4.871094 28.144531l71.535156 50.429688-1.921875 69.832031c-.304687 11.148437 8.484375 20.433593 19.632813 20.742187 11.132812.304688 20.4375-8.472656 20.742187-19.632812zm0 0" fill="#ba6746" />
							<path d="m105.3125 190.242188 37.546875-15.015626-15.554687-45.058593c-3.640626-10.542969-15.140626-16.144531-25.679688-12.5-10.542969 3.640625-16.140625 15.140625-12.5 25.683593zm0 0" fill="#4699f2" />
							<path d="m395.59375 141.214844-37.605469-26.511719c-9.117187-6.425781-21.71875-4.246094-28.144531 4.871094-6.433594 9.113281-4.246094 21.714843 4.871094 28.140625l39.023437 27.511718zm0 0" fill="#ffc305" />
						</svg>
						<!--begin::Svg Icon | path:assets/media/svg/icons/Tools/Compass.svg-->
						<!--end::Svg Icon-->
					</span>
				</div>
				<div *ngIf="_userSession.planes && _userSession.planes.length > 0 && planActivo && planActivo.isDemo" class="alert-text">
					¡Bienvenido a <strong>SimpleFactura</strong>!. Estás usando tu período de <span style="color: red">evaluación gratuita</span>.
					<span *ngIf="planActivo.diasDiferencia > 0"
						>Te quedan <span style="color: red">{{ planActivo.diasDiferencia + 1 }} días de uso</span>.</span
					>
					<span *ngIf="planActivo.diasDiferencia < 0 && planActivo.diasDiferencia >= -15 && !planActivo.isDemo"
						>Si contratas un plan, tendrás <span style="color: red">{{ planActivo.diasDiferencia * -1 }} días de mora</span>.</span
					>
					<span *ngIf="planActivo.diasDiferencia < -15 && !planActivo.isDemo">
						Tu nueva vigencia comenzará desde la fecha del nuevo pago.
					</span>
				</div>
				<div *ngIf="_userSession.planes && _userSession.planes.length > 0 && planActivo && planActivo.pagado && planActivo.diasDiferencia > 0" class="alert-text">
					¡Bienvenido a <strong>SimpleFactura</strong>!. Tu plan <strong>{{ planActivo.nombrePlan }}</strong> está vigente.
				</div>
				<div *ngIf="_userSession.planes && _userSession.planes.length > 0 && planActivo && planActivo.diasDiferencia <= 0 && planActivo.diasDiferencia >= -15 && !planActivo.isDemo" class="alert-text">
					¡Bienvenido a <strong>SimpleFactura</strong>!. Tu plan <strong>{{ planActivo.nombrePlan }}</strong> tiene una mora de <span style="color: red">{{ planActivo.diasDiferencia == 0 ? 1 : planActivo.diasDiferencia * -1 }} días</span>.
				</div>
				<div *ngIf="_userSession.planes && _userSession.planes.length > 0 && planActivo && planActivo.diasDiferencia < -15 && !planActivo.isDemo" class="alert-text">
					Tu plan <strong>{{ planActivo.nombrePlan }}</strong> ya no está vigente. Puedes renovarlo y comenzar una nueva vigencia desde el pago.
				</div>
				<div *ngIf="_userSession.planes && _userSession.planes.length > 0 && planActivo && !planActivo.pagado && !planActivo.isDemo && planActivo.diasDiferencia > 0" class="alert-text">
					¡Bienvenido a <strong>SimpleFactura</strong>!. Tu plan <strong>{{ planActivo.nombrePlan }}</strong> está <span style="color: red">pendiente de pago</span>.
				</div>
			</div>
			<!--end::Separator-->
		</div>
		<!--end::Content-->
	</ng-container>
</div>
<!-- end::User Panel-->
